module.exports = __webpack_public_path__ + "static/media/135_Ivywall.b08c78fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135_Ivywall.jpg
// module id = 532
// module chunks = 0